import React, { useState, useEffect, useRef } from 'react';
import { Calendar } from 'primereact/calendar';
import { Button } from 'primereact/button';
import { Toast } from 'primereact/toast';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import moment from 'moment';
import API from "../../Helper/server/API";
import './ServiceDashboard.css';
import { _endPoints } from '../../Helper/links';
import { Skeleton } from 'primereact/skeleton';

const ServiceDashboard = () => {
    const [date, setDate] = useState(new Date());
    const [stats, setStats] = useState(null);
    const [loading, setLoading] = useState(false);
    const toast = useRef(null);

    const fetchStats = async (selectedDate) => {
        setLoading(true);
        const formattedDate = moment(selectedDate).format('YYYY-MM-DD');
        try {
            const response = await API.get(_endPoints.reservations.services.get_dashboard_stats + '?date=' + formattedDate);
            if (response && response.success === 1) {
                setStats(response.data);
            } else {
                toast.current.show({ severity: 'error', summary: 'خطأ', detail: response?.msg || 'حدث خطأ في جلب البيانات' });
            }
        } catch (error) {
            toast.current.show({ severity: 'error', summary: 'خطأ', detail: 'تعذر الاتصال بالخادم' });
        }
        setLoading(false);
    };

    useEffect(() => {
        fetchStats(date);
    }, [date]);

    const handlePrint = () => {
        window.print();
    };

    return (
        <div className="page-wrapper" dir="rtl" >
            <div className="content-wrapper">
                <Toast ref={toast} />
                <br></br>

                <div className="print-header">
                    <h2>تقرير العمليات اليومي</h2>
                    <p>التاريخ: {moment(date).format('YYYY-MM-DD')}</p>
                    <hr />
                </div>

                <div className="dashboard-header">
                    <h1 className="dashboard-title">إحصائيات العمليات اليومية</h1>
                    <div className="header-actions">
                        <Calendar
                            value={date}
                            onChange={(e) => setDate(e.value)}
                            dateFormat="yy-mm-dd"
                            showIcon
                            className='col-12 '
                            placeholder="اختر التاريخ"
                            panelStyle={{ width: "40rem" }}
                        />
                        {/* <Button
                            icon="pi pi-print"
                            label="طباعة التقرير"
                            className="p-button-outlined p-button-secondary no-print"
                            onClick={handlePrint}
                        /> */}
                        <Button
                            icon="pi pi-refresh"
                            className="p-button-rounded p-button-text no-print"
                            onClick={() => fetchStats(date)}
                            loading={loading}
                        />
                    </div>
                </div>

                {loading ? (
                    <div style={{ textAlign: 'center', marginTop: '50px' }}>
                        <div className="stats-grid">
                            <div className="stat-card revenue">
                                <div className="stat-title">إجمالي الإيرادات</div>
                                <div className="stat-value"><Skeleton></Skeleton></div>
                            </div>
                            <div className="stat-card bookings">
                                <div className="stat-title">إجمالي الحجوزات</div>
                                <div className="stat-value"><Skeleton></Skeleton></div>
                            </div>
                            <div className="stat-card people">
                                <div className="stat-title">إجمالي الأشخاص</div>
                                <div className="stat-value"><Skeleton></Skeleton></div>
                            </div>
                            <div className="stat-card bracelets">
                                <div className="stat-title">الأساور المفعلة</div>
                                <div className="stat-value"><Skeleton></Skeleton></div>
                            </div>
                            <div className="stat-card bracelets">
                                <div className="stat-title">الأساور المضافة</div>
                                <div className="stat-value"><Skeleton></Skeleton></div>
                            </div>
                            <div className="stat-card bracelets">
                                <div className="stat-title">الأساور المسترجعة/الملغية</div>
                                <div className="stat-value"><Skeleton></Skeleton></div>
                            </div>
                            <div className="stat-card people">
                                <div className="stat-title">الأماكن المتاحة</div>
                                <div className="stat-value"><Skeleton></Skeleton></div>
                            </div>
                        </div>
                        <Skeleton></Skeleton>
                    </div>
                ) : stats ? (
                    <>
                        <div className="stats-grid">
                            <div className="stat-card revenue">
                                <div className="stat-title">إجمالي الإيرادات</div>
                                <div className="stat-value">{stats.total_revenue} د.ل</div>
                            </div>
                            <div className="stat-card bookings">
                                <div className="stat-title">إجمالي الحجوزات</div>
                                <div className="stat-value">{stats.total_bookings}</div>
                            </div>
                            <div className="stat-card people">
                                <div className="stat-title">إجمالي الأشخاص</div>
                                <div className="stat-value">{stats.total_people}</div>
                            </div>
                            <div className="stat-card bracelets">
                                <div className="stat-title">الأساور المفعلة</div>
                                <div className="stat-value">{stats.activated_bracelets}</div>
                            </div>
                            <div className="stat-card bracelets">
                                <div className="stat-title">الأساور المضافة</div>
                                <div className="stat-value">{stats.added_bracelets}</div>
                            </div>
                            <div className="stat-card bracelets">
                                <div className="stat-title">الأساور المسترجعة/الملغية</div>
                                <div className="stat-value">{stats.removed_bracelets}</div>
                            </div>
                            <div className="stat-card people">
                                <div className="stat-title">الأماكن المتاحة</div>
                                <div className="stat-value">{stats.available_spaces}</div>
                            </div>
                        </div>

                        {stats.services && stats.services.length > 0 && (
                            <div className="services-list-container" style={{ marginTop: '2rem' }}>
                                <h2 style={{ marginBottom: '1rem' }}>قائمة الخدمات المتاحة</h2>
                                <DataTable value={stats.services} responsiveLayout="scroll" className="p-datatable-sm p-datatable-striped" emptyMessage="لا توجد خدمات متاحة">
                                    <Column field="service_name_ar" header="اسم الخدمة" style={{ textAlign: "right" }}></Column>
                                    <Column field="capacity" header="السعة الإجمالية" body={(rowData) => rowData.capacity || 'غير محدد'} style={{ textAlign: "right" }} ></Column>
                                    <Column field="capacity_occupied" header="المحجوز" body={(rowData) => rowData.capacity_occupied || 0} style={{ textAlign: "right" }}></Column>
                                    <Column field="capacity_available" header="الأماكن المتاحة" body={(rowData) => rowData.capacity_available !== undefined ? rowData.capacity_available : 'غير محدد'} style={{ textAlign: "right" }}></Column>
                                </DataTable>
                            </div>
                        )}
                    </>
                ) : null}
            </div>
        </div>

    );
};

export default ServiceDashboard;
